import { SCREEN_LG_MAX } from "../../shared/global/variables";
import { debounce } from "../../plugins/debounce";

function statementBox() {
	const statementBox = document.querySelector('[data-js="statement-box"]');
	if (statementBox) {
		const breakpoint = window.matchMedia(`(max-width: ${SCREEN_LG_MAX}px)`);

		const header = document.querySelector("header");
		const main = document.querySelector("main");
		const clientTypeNavigation = document.querySelector(
			".client-type-navigation"
		);
		const clientTypeNavigationMenu = clientTypeNavigation.querySelector(
			".client-type-navigation__sites"
		);
		const mainNavigation = document.querySelector(".main-navigation__container");
		const menus = [
			mainNavigation.querySelector(".menu"),
			...mainNavigation.querySelectorAll(".menu__level2"),
		];

		const headerHeight = checkHeight(document.querySelector("header"));

		const toggleButton = statementBox.querySelector(".statement-box__toggle");

		adjustFixedElements(
			breakpoint,
			main,
			header,
			clientTypeNavigation,
			clientTypeNavigationMenu,
			menus,
			statementBox
		);
		const adjustOnResize = debounce(() => {
			adjustFixedElements(
				breakpoint,
				main,
				header,
				clientTypeNavigation,
				clientTypeNavigationMenu,
				menus,
				statementBox
			);
		}, 10);
		window.addEventListener("resize", adjustOnResize);

		document.addEventListener("scroll", function () {
			if (breakpoint.matches) {
				if (document.body.classList.contains("menuFloating")) {
					menus.forEach((menu) => {
						menu.style.top = "";
						menu.style.height = "";
					});
				} else {
					menus.forEach((menu) => {
						menu.style.top = `${headerHeight}px`;
						menu.style.height = `calc(100% - ${headerHeight}px)`;
					});
				}
			}
		});

		if (
			!localStorage.getItem("uokik") &&
			!document.body.classList.contains("is-mobile")
		) {
			toggleStatementBox(statementBox, toggleButton);
		}
		toggleButton.addEventListener("click", (e) => {
			toggleStatementBox(statementBox, toggleButton);
			if (!localStorage.getItem("uokik")) {
				localStorage.setItem("uokik", "hide");
			}
		});
	}
}

function toggleStatementBox(box, button) {
	const dataShow = button.dataset.show;
	const dataHide = button.dataset.hide;
	if (!box.classList.contains("expanded")) {
		box.classList.add("expanded");
		button.innerText = dataHide;
		button.setAttribute("aria-expanded", "true");
	} else {
		box.classList.remove("expanded");
		button.innerText = dataShow;
		button.setAttribute("aria-expanded", "false");
	}
}

function checkHeight(box) {
	return box.offsetHeight;
}

function adjustFixedElements(
	breakpoint,
	main,
	header,
	clientTypeNavigation,
	clientTypeNavigationMenu,
	menus,
	statementBox
) {
	if (!statementBox.classList.contains("expanded")) {
		main.style.marginTop = `${checkHeight(header)}px`;
	}
	clientTypeNavigationMenu.style.top = `${
		checkHeight(clientTypeNavigation) + checkHeight(statementBox)
	}px`;

	adjustMenus(breakpoint, menus, checkHeight(header));
}

function adjustMenus(breakpoint, menus, height) {
	menus.forEach((menu) => {
		if (breakpoint.matches) {
			menu.style.top = `${height}px`;
			menu.style.height = `calc(100% - ${height}px)`;
		} else {
			menu.style.top = "";
			menu.style.height = "";
		}
	});
}

export default statementBox;
